export const APP_PERMISSIONS = {
  ADMIN_USERS_MANAGE: "admin.users.manage",
  ADMIN_COMPANIES_MANAGE: "admin.companies.manage",
  ADMIN_MEMBERSHIPS_MANAGE: "admin.memberships.manage",
  ADMIN_INVITES_MANAGE: "admin.invites.manage",
  ADMIN_ROLES_MANAGE: "admin.roles.manage",
  PLANS_ACTUALS_USE: "plans_actuals.use",
} as const;

export const APP_ROLES = {
  APP_ADMIN: "app_admin",
  PLANS_ACTUALS: "plans_actuals",
} as const;

export function isAppAdmin(roles: readonly string[]): boolean {
  return roles.includes(APP_ROLES.APP_ADMIN);
}

export function hasAppPermission(permissions: readonly string[], target: string): boolean {
  return permissions.includes(target);
}

export function hasAnyAppPermission(
  permissions: readonly string[],
  targets: readonly string[],
): boolean {
  return targets.some((target) => hasAppPermission(permissions, target));
}

/** The Plans and Actuals feature needs the deployment flag and the feature permission. */
export function canUsePlansActuals(
  featureEnabled: boolean,
  permissions: readonly string[],
): boolean {
  return featureEnabled && hasAppPermission(permissions, APP_PERMISSIONS.PLANS_ACTUALS_USE);
}
